import { DodocParser } from './DodocParser';
import { FilesParser } from './FilesParser';
import { GenericParser } from './GenericParser';
import { OfficeParser } from './OfficeParser';
import { PlainTextParser } from './PlainTextParser';

export class ParserFactory {
  static DODOC: Editor.Clipboard.ParserKeys = 'dodoc/html';
  static HTML: Editor.Clipboard.ParserKeys = 'text/html';
  static PLAIN_TEXT: Editor.Clipboard.ParserKeys = 'text/plain';
  static FILES: Editor.Clipboard.ParserKeys = 'Files';

  static getParser(
    context: Editor.Edition.Context,
    type: Editor.Clipboard.ParserKeys,
    dataTransfer: DataTransfer,
  ) {
    switch (type) {
      case ParserFactory.DODOC:
        return new DodocParser(context, dataTransfer.getData(type));
      case ParserFactory.PLAIN_TEXT:
        return new PlainTextParser(context, dataTransfer.getData(type));
      case ParserFactory.FILES:
        return new FilesParser(context, Array.from(dataTransfer.items));
      case ParserFactory.HTML:
        return ParserFactory.getHtmlParser(context, dataTransfer.getData(type));
      default:
        throw new Error(`Invalid parser for type: ${type}`);
    }
  }

  static getHtmlParser(context: Editor.Edition.Context, data: string) {
    const regex =
      /(?:.*xmlns:([a-z])="urn:schemas-microsoft-com:office:([a-z]*)".*|xmlns:m="http:\/\/schemas\.microsoft\.com\/office\/2004\/12\/omml")+/gm;
    const matches = data.match(regex);
    if (
      matches &&
      matches.length > 0 &&
      (matches[0].includes('xmlns:o') || matches[0].includes('xmlns:m'))
    ) {
      return new OfficeParser(context, data);
    }
    return new GenericParser(context, data);
  }

  static getAvailableParsers() {
    return [ParserFactory.DODOC, ParserFactory.HTML, ParserFactory.PLAIN_TEXT, ParserFactory.FILES];
  }
}
